<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-content" v-loading="isLoading">
        <div class="calendar">
          <div class="calendar-header">
            <div class="date-ctrl">
              <div class="arrow" @click="changeMonth('reduce')">
                <svg
                  width="9"
                  height="14"
                  xmlns="http://www.w3.org/2000/svg"
                  class="zb-pagination-arrow"
                >
                  <path
                    d="M8 1L1.78 7 8 13"
                    stroke-width="2"
                    fill="none"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </div>
              <div class="date">
                <!-- {{ date.pattern("yyyy") }}年 {{ date.pattern("MM") }}月 -->

                <el-date-picker
                  v-model="date"
                  type="month"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  placeholder="选择年月"
                >
                </el-date-picker>
              </div>
              <div class="arrow" @click="changeMonth('add')">
                <svg
                  width="9"
                  height="14"
                  xmlns="http://www.w3.org/2000/svg"
                  class="zb-pagination-arrow"
                >
                  <path
                    d="M1 1l6.22 6L1 13"
                    stroke-width="2"
                    fill="none"
                    fill-rule="evenodd"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <div class="calendar-body g-block">
            <div class="zb-grid zb-grid-bordered">
              <table class="zb-grid-table">
                <colgroup>
                  <col style="width: 20px; min-width: 20px" />
                </colgroup>
                <thead class="zb-grid-thead">
                  <tr class="zb-grid-tr">
                    <th class="zb-grid-th">
                      <label
                        class="zb-checkbox-wrap"
                        :class="{
                          'zb-checkbox-checked': allChecked,
                          'zb-checkbox-indeterminate': isIndeterminate,
                        }"
                        ><span class="zb-checkbox">
                          <span class="zb-checkbox-inner"></span>
                          <input type="checkbox" v-model="allChecked" /></span
                      ></label>
                    </th>
                    <th
                      class="zb-grid-th"
                      v-for="(item, index) in weekDays"
                      :key="item.value"
                    >
                      <div class="title">
                        <label
                          class="zb-checkbox-wrap"
                          :class="{
                            'zb-checkbox-checked': !!~weekDaysCheckbox.indexOf(index),
                          }"
                        >
                          <span class="zb-checkbox"
                            ><span class="zb-checkbox-inner"></span
                            ><input
                              type="checkbox"
                              :value="index"
                              v-model="weekDaysCheckbox" /></span></label
                        ><i>{{ item.label }}</i>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody class="zb-grid-tbody">
                  <tr class="zb-grid-tr" v-for="(item, index) in rows" :key="index">
                    <td class="zb-grid-td">
                      <span>
                        <label
                          class="zb-checkbox-wrap"
                          :class="{
                            'zb-checkbox-checked': !!~rowCheck.indexOf(index),
                          }"
                        >
                          <span class="zb-checkbox">
                            <span class="zb-checkbox-inner"></span>
                            <input type="checkbox" :value="index" v-model="rowCheck" />
                          </span>
                        </label>
                      </span>
                    </td>
                    <td class="zb-grid-td" v-for="subitem in item" :key="subitem.text">
                      <div
                        class="management-td-wrap"
                        :class="{
                          disable: isDisable(subitem),
                          'zb-checkbox-checked': !!~rowsCheck.indexOf(
                            combinationRowsValue(subitem)
                          ),
                        }"
                        @click="
                          !isDisable(subitem)
                            ? ''
                            : changeMonth(
                                subitem.type == 'next'
                                  ? 'add'
                                  : subitem.type == 'prev'
                                  ? 'reduce'
                                  : ''
                              )
                        "
                      >
                        <span
                          class="tag"
                          :class="{
                            notholiday: !holidayMap[combinationRowsValue(subitem)]
                              .holiday,
                          }"
                          v-if="holidayMap[combinationRowsValue(subitem)]"
                          >{{
                            holidayMap[combinationRowsValue(subitem)].holiday
                              ? "假"
                              : "班"
                          }}</span
                        >
                        <span class="date">{{ subitem.text }}</span>
                        <div class="checkbox" v-if="!isDisable(subitem)" @click.stop>
                          <label class="zb-checkbox-wrap" :class="{}"
                            ><span class="zb-checkbox">
                              <!-- <span class="zb-checkbox-inner"></span
                              > -->
                              <input
                                type="checkbox"
                                :value="combinationRowsValue(subitem)"
                                v-model="rowsCheck" /></span
                          ></label>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="service-list">
          <h3 class="title">服务</h3>
          <el-tag
            v-for="(item, index) in serviceList"
            :key="item.goodsId"
            closable
            :disable-transitions="false"
            @close="deleteService(item.goodsId)"
          >
            {{ item.goodsName }}
          </el-tag>
          <el-button type="primary" size="small" @click="openDialogFuc">添加</el-button>
        </div>
        <div class="price-change-list">
          <h3 class="title">改价列表</h3>
          <div class="date-list-wrap">
            <div class="week-list">
              <el-button
                size="small"
                plain
                v-for="item in rowsCheckWeekDays"
                :key="item.label"
                :type="weekDaysSelList.indexOf(item.value) != -1 ? 'primary' : ''"
                @click="toggleWeekDaysItem(item.value)"
                >{{ item.label }}</el-button
              >
              <el-button
                v-if="rowsCheckSelList.length"
                size="small"
                plain
                type="danger"
                @click="(rowsCheckSelList = []), (weekDaysSelList = [])"
                >全部取消</el-button
              >
              <el-button
                v-if="rowsCheckSelList.length >= 2"
                size="small"
                plain
                type="success"
                @click="syncPrice"
                >同步价格</el-button
              >
            </div>
            <div class="date-list">
              <el-button
                round
                size="small"
                v-for="item in rowsCheck"
                :key="item"
                :type="rowsCheckSelList.indexOf(item) != -1 ? 'primary' : ''"
                @click="toggleItem(rowsCheckSelList, item)"
                :disabled="+new Date(item) < +new Date() - 3600 * 1000 * 24"
                >{{ item }}</el-button
              >
            </div>
          </div>
          <div class="service-price-list">
            <div class="service-item" v-if="servicePriceList.length">
              <div class="item">
                <div class="name">服务名称（规格）</div>
                <div class="fixed-width">原价</div>
                <div class="fixed-width">原会员价</div>
                <div class="fixed-width">价格</div>
                <div class="fixed-width">会员价格</div>
              </div>
            </div>
            <div class="service-item" v-for="serviceItem in servicePriceList">
              <div class="item">
                <div class="name">{{ serviceItem.goodsName }}</div>
                <template v-if="!serviceItem.products || !serviceItem.products.length">
                  <div class="fixed-width">
                    {{ serviceItem.originalRetailPrice }}
                  </div>
                  <div class="fixed-width">
                    {{ serviceItem.originalMemberPrice }}
                  </div>
                  <div class="fixed-width">
                    <el-input
                      placeholder="填写价格"
                      v-model="serviceItem.retailPrice"
                      size="small"
                      @input.native="
                        numberInputChange($event, serviceItem, 'retailPrice')
                      "
                      @blur="numberInputBlur"
                      clearable
                      type="number"
                      min="1"
                    ></el-input>
                  </div>
                  <div class="fixed-width">
                    <el-input
                      placeholder="填写会员价格"
                      v-model="serviceItem.memberPrice"
                      size="small"
                      @input.native="
                        numberInputChange($event, serviceItem, 'memberPrice')
                      "
                      @blur="numberInputBlur"
                      clearable
                      type="number"
                      min="1"
                    ></el-input>
                  </div>
                </template>
              </div>

              <template v-if="serviceItem.products && serviceItem.products.length">
                <div
                  class="item products"
                  v-for="(item, index) in serviceItem.products"
                  :key="index"
                >
                  <div class="name">
                    {{ item.valueContent }}
                  </div>
                  <div class="fixed-width">
                    {{ item.originalRetailPrice }}
                  </div>
                  <div class="fixed-width">
                    {{ item.originalMemberPrice }}
                  </div>
                  <div class="fixed-width">
                    <el-input
                      placeholder="填写价格"
                      v-model="item.retailPrice"
                      size="small"
                      @input.native="numberInputChange($event, item, 'retailPrice')"
                      @blur="numberInputBlur"
                      clearable
                      type="number"
                      min="1"
                    ></el-input>
                  </div>
                  <div class="fixed-width">
                    <el-input
                      placeholder="填写会员价格"
                      v-model="item.memberPrice"
                      size="small"
                      @input.native="numberInputChange($event, item, 'memberPrice')"
                      @blur="numberInputBlur"
                      clearable
                      type="number"
                      min="1"
                    ></el-input>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="list-footer">
          <el-button type="primary" size="small" @click="confirmChange">确定</el-button>
        </div>
      </div>
    </div>
    <dialog-sel-goods-multiple
      ref="selGoods"
      :goodsShopType="4"
      @confirmSelGoods="confirmSelService"
    >
    </dialog-sel-goods-multiple>
  </div>
</template>

<script>
import {
  getHoliday,
  findGoodsDynamicPriceList,
  saveOrUpdateBatchGoodsDynamicPrice,
} from "@/api/index";
import {
  range as rangeArr,
  getFirstDayOfMonth,
  getPrevMonthLastDays,
  getMonthDays,
} from "@/utils/date-util";
import { commonFuc } from "@/mixins/commonFuc";
import dialogSelGoodsMultiple from "@/components/dialogSelGoodsMultiple";
import index from "@xkeshi/vue-qrcode";
export default {
  mixins: [commonFuc],
  data() {
    return {
      date: new Date().pattern("yyyy-MM"),
      currentDate: new Date(),
      isLoading: false,
      firstDayOfWeek: 0,
      WEEK_DAYS: [
        { label: "周日", value: 0 },
        { label: "周一", value: 1 },
        { label: "周二", value: 2 },
        { label: "周三", value: 3 },
        { label: "周四", value: 4 },
        { label: "周五", value: 5 },
        { label: "周六", value: 6 },
      ],
      allChecked: false,
      isIndeterminate: false,
      weekDaysCheckbox: [],
      rowCheck: [],
      rowsCheck: [],
      schedulingDate: "",
      schedulingDateText: "",
      scheduleId: "",
      mapWorkUser: {},
      workUserId: "",
      nickName: "",
      baseCrasftmanList: [],
      isIndeterminate: false,
      checkAll: false,
      craftsmanList: [],
      filterText: "",
      currentCrasftmanList: [],
      mapOutScheduling: {},
      isShowOutPop: {},
      isLoadingOut: false,
      getOutDetailsTimer: null,
      hideTimer: null,
      serviceList: [],
      oldServiceList: [],
      serviceMap: {},
      servicePriceList: [],
      rowsCheckSelList: [],
      oldRowsCheckSelList: [],
      isSwitchRowsCheckSel: false,
      weekDaysSelList: [],
      servicePriceMap: {},
      holidayMap: {},
    };
  },
  components: {
    dialogSelGoodsMultiple,
  },
  computed: {
    rowsCheckWeekDays() {
      let list = [];
      this.rowsCheck.forEach((val) => {
        let weekIndex = this.WEEK_DAYS.findIndex((week, index) => {
          console.log("week", week.value, val);
          return week.value == new Date(val).getDay();
        });
        if (
          weekIndex != -1 &&
          list.findIndex(
            (listItem) => listItem.value == this.WEEK_DAYS[weekIndex].value
          ) == -1
        ) {
          list.push(this.WEEK_DAYS[weekIndex]);
        }
        if (this.holidayMap[val] && this.holidayMap[val].holiday) {
          let holidayIndex = list.findIndex((item) => {
            return item.label == this.holidayMap[val].name;
          });
          if (holidayIndex != -1) {
            list[holidayIndex].value.push(val);
          } else {
            list.push(
              Object.assign({}, this.holidayMap[val], {
                label: this.holidayMap[val].name,
                value: [this.holidayMap[val].date],
              })
            );
          }
        }
      });
      console.log(list);
      return list;
    },
    weekDays() {
      const start = this.firstDayOfWeek;
      const { WEEK_DAYS } = this;

      if (typeof start !== "number" || start === 0) {
        return WEEK_DAYS.slice();
      } else {
        return WEEK_DAYS.slice(start).concat(WEEK_DAYS.slice(0, start));
      }
    },
    rows() {
      let days = [];
      const date = new Date(this.date);
      let firstDay = getFirstDayOfMonth(date);
      firstDay = firstDay === 0 ? 7 : firstDay;
      const firstDayOfWeek =
        typeof this.firstDayOfWeek === "number" ? this.firstDayOfWeek : 1;
      const prevMonthDays = getPrevMonthLastDays(date, firstDay - firstDayOfWeek).map(
        (day) => ({
          text: day,
          type: "prev",
        })
      );
      const currentMonthDays = getMonthDays(date).map((day) => ({
        text: day,
        type: "current",
        nickNames: "",
      }));
      if (prevMonthDays.length == 7) {
        days = [...currentMonthDays];
      } else {
        days = [...prevMonthDays, ...currentMonthDays];
      }
      let baseDays = 35;
      if (days.length > baseDays) {
        baseDays = 42;
      }
      const nextMonthDays = rangeArr(baseDays - days.length).map((_, index) => ({
        text: index + 1,
        type: "next",
      }));
      days = days.concat(nextMonthDays);
      return this.toNestedArr(days);
    },
    showCraftsmanList() {
      return this.craftsmanList.filter((val) => {
        return val.nickName.indexOf(this.filterText) !== -1;
      });
    },
  },
  watch: {
    weekDaysCheckbox(val, oldVal) {
      let difArr = this.getArrDifference(val, oldVal);
      console.log(difArr);
      if (val.length > oldVal.length) {
        difArr.forEach((subval) => {
          this.rows.forEach((row) => {
            if (
              !this.isDisable(row[subval]) &&
              this.rowsCheck.indexOf(this.combinationRowsValue(row[subval])) == -1
            ) {
              this.rowsCheck.push(this.combinationRowsValue(row[subval]));
              this.rowsCheck.sort((a, b) => new Date(a) - new Date(b));
            }
          });
        });
      } else {
        difArr.forEach((subval) => {
          this.rows.forEach((row) => {
            if (!this.isDisable(row[subval])) {
              console.log(
                row[subval],
                this.rowsCheck,
                this.combinationRowsValue(row[subval])
              );
              if (this.rowsCheck.indexOf(this.combinationRowsValue(row[subval])) != -1) {
                this.rowsCheck.splice(
                  this.rowsCheck.indexOf(this.combinationRowsValue(row[subval])),
                  1
                );
              }
            }
          });
        });
      }
    },
    rowCheck(val, oldVal) {
      let difArr = this.getArrDifference(val, oldVal);
      if (this.rows.length == val.length) {
        this.allChecked = true;
        this.isIndeterminate = false;
      } else {
        console.log(this.getArrDifference(val, oldVal));
        if (val.length > oldVal.length) {
          difArr.forEach((subval) => {
            this.rows[subval].forEach((subitem) => {
              if (
                !this.isDisable(subitem) &&
                this.rowsCheck.indexOf(this.combinationRowsValue(subitem)) == -1
              ) {
                this.rowsCheck.push(this.combinationRowsValue(subitem));
                this.rowsCheck.sort((a, b) => new Date(a) - new Date(b));
              }
            });
          });
        } else {
          difArr.forEach((subval) => {
            this.rows[subval].forEach((subitem) => {
              if (!this.isDisable(subitem)) {
                if (this.rowsCheck.indexOf(this.combinationRowsValue(subitem)) != -1) {
                  this.rowsCheck.splice(
                    this.rowsCheck.indexOf(this.combinationRowsValue(subitem)),
                    1
                  );
                }
              }
            });
          });
        }
        if (!val.length) {
          if (!this.rowsCheck.length) {
            this.weekDaysCheckbox = [];
          }
          this.allChecked = false;
          this.isIndeterminate = false;
        } else {
          this.isIndeterminate = true;
        }
        if (this.allChecked) {
          this.allChecked = false;
          this.isIndeterminate = true;
        }
      }
    },
    allChecked(val) {
      if (val) {
        this.rowCheck = [];
        this.rows.forEach((val, index) => {
          this.rowCheck.push(index);
        });
        this.weekDaysCheckbox = [];
        this.weekDays.forEach((val, index) => {
          this.weekDaysCheckbox.push(index);
        });
      } else {
        if (!this.isIndeterminate) {
          this.rowCheck = [];
          this.weekDaysCheckbox = [];
        }
      }
    },
    rowsCheck(val, oldVal) {
      console.log("rowsCheck", val);
      let weekCanList = {};
      let rowCanList = {};
      this.rows.forEach((row, rowIndex) => {
        row.forEach((item, index) => {
          if (!this.isDisable(item)) {
            if (!rowCanList[rowIndex]) {
              rowCanList[rowIndex] = 1;
            } else {
              rowCanList[rowIndex]++;
            }
            if (!weekCanList[index]) {
              weekCanList[index] = 1;
            } else {
              weekCanList[index]++;
            }
          }
        });
      });
      this.rows.forEach((row, rowIndex) => {
        row.forEach((item, index) => {
          if (
            !this.isDisable(item) &&
            val.indexOf(this.combinationRowsValue(item)) != -1
          ) {
            weekCanList[index]--;
            rowCanList[rowIndex]--;
          }
        });
      });
      Object.keys(weekCanList).forEach((weekVal) => {
        let week = Number(weekVal);
        let isHav = this.weekDaysCheckbox.indexOf(week) != -1;
        console.log(weekCanList, week);
        if (!weekCanList[week]) {
          if (!isHav) {
            this.weekDaysCheckbox.push(week);
          }
        } else {
          if (isHav) {
            this.weekDaysCheckbox.splice(this.weekDaysCheckbox.indexOf(week), 1);
          }
        }
      });
      Object.keys(rowCanList).forEach((rowVal) => {
        let row = Number(rowVal);
        let isHav = this.rowCheck.indexOf(row) != -1;
        console.log(rowCanList, row);
        if (!rowCanList[row]) {
          if (!isHav) {
            this.rowCheck.push(row);
          }
        } else {
          if (isHav) {
            this.rowCheck.splice(this.rowCheck.indexOf(row), 1);
          }
        }
      });
      console.log(val);
      let servicePriceMap = {};
      val.forEach((rowItem) => {
        if (!this.servicePriceMap[rowItem]) {
          servicePriceMap[rowItem] = JSON.parse(JSON.stringify(this.serviceList));
        } else {
          servicePriceMap[rowItem] = JSON.parse(
            JSON.stringify(this.servicePriceMap[rowItem])
          );
        }
      });
      this.servicePriceMap = servicePriceMap;
      console.log("servicePriceMap", this.servicePriceMap);
      if (!val.length) {
        this.rowsCheckSelList = [];
      } else {
        let rowsCheckSelList = JSON.parse(JSON.stringify(this.rowsCheckSelList));
        let selList = rowsCheckSelList.filter((selitem, index) => {
          if (val.indexOf(selitem) == -1) {
            this.rowsCheckSelList.splice(index, 1);
          }
          return val.indexOf(selitem) != -1;
        });
        console.log("selList", selList);
        if (!selList.length) {
          this.servicePriceList = [];
        }
      }
    },
    date(val, oldVal) {
      console.log(val, oldVal);
      if (new Date(val).getFullYear() != new Date(oldVal).getFullYear()) {
        this.getHolidayFuc();
      }
      let oldRowsCheck = JSON.stringify(this.rowsCheck);
      this.rowsCheck = [];
      this.allChecked = false;
      this.weekDaysCheckbox = [];
      this.rowCheck = [];
      this.$nextTick(() => {
        this.rowsCheck = JSON.parse(oldRowsCheck);
      });
    },
    servicePriceList: {
      handler: function (list) {
        if (this.isSwitchRowsCheckSel) {
          this.isSwitchRowsCheckSel = false;
          return;
        }
        if (list.length) {
          console.log("servicePriceList", list);
          this.rowsCheckSelList.forEach((rowItem) => {
            this.servicePriceMap[rowItem] = JSON.parse(JSON.stringify(list));
          });
        }
      },
      deep: true,
    },
    rowsCheckSelList(list) {
      const oldList = this.oldRowsCheckSelList;
      console.log("rowsCheckSelList", list);
      if (list.length) {
        console.log(
          "this.servicePriceMap[list[0]]",
          this.servicePriceMap[list[0]],
          list[0]
        );
        if (!this.servicePriceList.length) {
          this.servicePriceList = JSON.parse(
            JSON.stringify(this.servicePriceMap[list[0]])
          );
        } else {
          if (oldList.length > list.length) {
            this.isSwitchRowsCheckSel = true;
            this.servicePriceList = JSON.parse(
              JSON.stringify(this.servicePriceMap[list[0]])
            );
          }
        }
      } else {
        this.servicePriceList = [];
      }
      this.oldRowsCheckSelList = [...list];
    },
    serviceList(list) {
      const oldList = this.oldServiceList;
      console.log("serviceList", list, oldList);
      if (list.length < oldList.length) {
        let deleteList = oldList.filter((oldItem) => {
          return list.findIndex((item) => oldItem.goodsId == item.goodsId) == -1;
        });
        console.log("deleteList", deleteList, list, oldList);
        deleteList.forEach((item) => {
          console.log("this.serviceMap[item.goodsId]", this.serviceMap, item);
          if (this.serviceMap[item.goodsId]) {
            delete this.serviceMap[item.goodsId];
          }
          Object.keys(this.servicePriceMap).forEach((servicePriceItem) => {
            let itemIndex = this.servicePriceMap[servicePriceItem].findIndex(
              (priceItem) => priceItem.goodsId == item.goodsId
            );
            if (itemIndex != -1) {
              this.servicePriceMap[servicePriceItem].splice(itemIndex, 1);
            }
          });
          if (this.rowsCheckSelList.length) {
            console.log(
              "this.servicePriceMap[this.rowsCheckSelList[0]]",
              this.servicePriceMap[this.rowsCheckSelList[0]]
            );
            this.servicePriceList = JSON.parse(
              JSON.stringify(this.servicePriceMap[this.rowsCheckSelList[0]])
            );
          }
        });
      }
      this.oldServiceList = [...list];
    },
  },
  mounted() {
    this.getHolidayFuc();
    this.findGoodsDynamicPriceListFuc();
    // setTimeout(() => {
    //   this.rowsCheck = [];
    // }, 1e3);
  },
  methods: {
    syncPrice() {
      this.rowsCheckSelList.forEach((rowItem) => {
        this.servicePriceMap[rowItem] = JSON.parse(JSON.stringify(this.servicePriceList));
      });
    },
    toggleItem(array, item) {
      const index = array.indexOf(item);
      if (index > -1) {
        // 找到，删除
        array.splice(index, 1);
      } else {
        // 没找到，添加
        array.push(item);
      }
    },
    toggleWeekDaysItem(item) {
      const index = this.weekDaysSelList.indexOf(item);
      console.log(index, item);
      if (index > -1) {
        // 找到，删除
        this.weekDaysSelList.splice(index, 1);
        if (typeof item == "object") {
          item.forEach((itemRow) => {
            this.rowsCheckSelList = this.rowsCheckSelList.filter(
              (rowItem) => itemRow != rowItem
            );
          });
        } else {
          this.rowsCheckSelList = this.rowsCheckSelList.filter(
            (rowItem) => item != new Date(rowItem).getDay()
          );
        }
      } else {
        // 没找到，添加
        this.weekDaysSelList.push(item);
        console.log("没找到，添加", index, item, typeof item);
        if (typeof item == "object") {
          item.forEach((itemRow) => {
            this.rowsCheck.forEach((rowItem) => {
              console.log(itemRow, rowItem);
              if (rowItem == itemRow && +new Date(rowItem) > +new Date()) {
                if (this.rowsCheckSelList.indexOf(rowItem) == -1) {
                  this.rowsCheckSelList.push(rowItem);
                }
              }
            });
          });
        } else {
          this.rowsCheck.forEach((rowItem) => {
            if (item == new Date(rowItem).getDay() && +new Date(rowItem) > +new Date()) {
              if (this.rowsCheckSelList.indexOf(rowItem) == -1) {
                this.rowsCheckSelList.push(rowItem);
              }
            }
          });
        }
      }
    },
    getHolidayFuc() {
      getHoliday({
        year: new Date(this.date).getFullYear(),
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          let holidayMap = {};
          Object.keys(res.data.holiday).forEach((val) => {
            this.holidayMap[new Date(this.date).pattern("yyyy-") + val] =
              res.data.holiday[val];
          });
          Object.assign(this.holidayMap, holidayMap);
          this.$forceUpdate();
        }
      });
    },
    findGoodsDynamicPriceListFuc() {
      findGoodsDynamicPriceList().then((res) => {
        if (res.code == 1) {
          this.rowsCheck = Object.keys(res.data);
          this.rowsCheck.sort((a, b) => new Date(a) - new Date(b));
          this.serviceList = res.data[this.rowsCheck[0]];
          this.serviceList.forEach((val) => {
            this.serviceMap[val.goodsId] = val;
          });
          this.servicePriceMap = res.data;
        }
      });
    },
    deleteService(goodsId) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let deleteSerivceIndex = this.serviceList.findIndex((val) => {
            return val.goodsId == goodsId;
          });
          this.serviceList.splice(deleteSerivceIndex, 1);
          delete this.serviceMap[goodsId];
          Object.keys(this.servicePriceMap).forEach((servicePriceItem) => {
            let deleteIndex = this.servicePriceMap[servicePriceItem].findIndex((val) => {
              return val.goodsId == goodsId;
            });
            this.servicePriceMap[servicePriceItem].splice(deleteIndex, 1);
          });
        })
        .catch(() => {});
    },
    openDialogFuc() {
      console.log("openDialog");
      let list = this.serviceList.map((val) => {
        return val.goodsId;
      });
      this.$refs.selGoods.openDialog(list);
    },
    confirmSelService(list) {
      this.serviceList = list.map((val, index) => {
        console.log(val, this.serviceMap[val.goodsId], index);
        let products = val.products.map((product) => {
          return {
            goodsId: product.goodsId,
            memberPrice: product.memberPrice,
            productId: product.productId,
            retailPrice: product.retailPrice,
            valueContent: product.valueContent,
            originalRetailPrice: product.retailPrice,
            originalMemberPrice: product.memberPrice,
          };
        });
        if (!this.serviceMap[val.goodsId]) {
          this.serviceMap[val.goodsId] = Object.assign(
            {},
            {
              goodsName: val.goodsName,
              goodsId: val.goodsId,
              retailPrice: val.retailPrice,
              memberPrice: val.memberPrice,
              originalRetailPrice: val.retailPrice,
              originalMemberPrice: val.memberPrice,
              products: JSON.parse(JSON.stringify(products)),
            }
          );
          let servicePriceMap = Object.assign({}, this.servicePriceMap);
          Object.keys(servicePriceMap).forEach((servicePriceItem) => {
            this.servicePriceMap[servicePriceItem].push(
              Object.assign(
                {},
                {
                  goodsName: val.goodsName,
                  goodsId: val.goodsId,
                  retailPrice: val.retailPrice,
                  memberPrice: val.memberPrice,
                  originalRetailPrice: val.retailPrice,
                  originalMemberPrice: val.memberPrice,
                  products: JSON.parse(JSON.stringify(products)),
                }
              )
            );
          });
          if (this.rowsCheckSelList.length) {
            this.servicePriceList = JSON.parse(
              JSON.stringify(this.servicePriceMap[this.rowsCheckSelList[0]])
            );
          }
        }
        return Object.assign(
          {},
          {
            goodsName: val.goodsName,
            goodsId: val.goodsId,
            retailPrice: val.retailPrice,
            memberPrice: val.memberPrice,
            originalRetailPrice: val.retailPrice,
            originalMemberPrice: val.memberPrice,
            products: JSON.parse(JSON.stringify(products)),
          }
        );
      });
      console.log("serviceList", this.serviceList);
    },
    handleCheckAllChange(val) {
      let options = [];
      this.showCraftsmanList.forEach((val) => {
        options.push(String(val.workUserId));
      });
      this.currentCrasftmanList = val ? options : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.craftsmanList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.craftsmanList.length;
    },
    toNestedArr(days) {
      return rangeArr(days.length / 7).map((_, index) => {
        const start = index * 7;
        return days.slice(start, start + 7);
      });
    },
    isDisable(item) {
      return (
        item.type != "current" ||
        (Number(item.text) < Number(new Date().getDate()) &&
          new Date(this.date).getMonth() == new Date().getMonth() &&
          new Date(this.date).getFullYear() == new Date().getFullYear()) ||
        (new Date(this.date).getMonth() < new Date().getMonth() &&
          new Date(this.date).getFullYear() == new Date().getFullYear()) ||
        new Date(this.date).getFullYear() < new Date().getFullYear()
      );
    },
    combinationRowsValue(value) {
      let text = value.text * 1 < 10 ? `0${value.text}` : value.text;
      if (value.type == "current") {
        return this.date + "-" + text;
      } else if (value.type == "prev") {
        return (
          new Date(
            new Date(this.date).setMonth(new Date(this.date).getMonth() - 1)
          ).pattern("yyyy-MM-") + text
        );
      } else {
        return (
          new Date(
            new Date(this.date).setMonth(new Date(this.date).getMonth() + 1)
          ).pattern("yyyy-MM-") + text
        );
      }
    },
    getArrDifference(arr1, arr2) {
      return arr1.concat(arr2).filter((v, i, arr) => {
        return arr.indexOf(v) === arr.lastIndexOf(v);
      });
    },
    changeMonth(type) {
      if (!type) {
        this.$notify.error("无法编辑过去时间");
        return;
      } else {
        // this.allChecked = false;
        // this.weekDaysCheckbox = [];
        // this.rowCheck = [];
        // this.rowsCheck = [];
      }
      let date = new Date(this.date);
      if (type == "add") {
        date.setMonth(date.getMonth() + 1);
      }
      if (type == "reduce") {
        date.setMonth(date.getMonth() - 1);
      }
      this.date = new Date(date).pattern("yyyy-MM");
    },
    formatWorkUser(workUserIds) {
      let nickNames = "";
      workUserIds.forEach((val) => {
        if (nickNames) {
          nickNames += `、${this.mapWorkUser[val].nickName}`;
        } else {
          nickNames = this.mapWorkUser[val].nickName;
        }
      });
      return nickNames;
    },
    numberInputChange(e, obj, key) {
      const val = e.target.value;
      if (val.includes(".") && val.split(".")[1].length >= 2) {
        const newVal = Number(val).toFixed(2);
        // 更新到 input
        e.target.value = newVal;
        // 更新到 v-model 绑定的数据
        obj[key] = newVal;
      }
    },
    numberInputBlur(e) {
      if (e.target.value.indexOf(".") == -1) {
        e.target.value = Number(e.target.value).toFixed(1);
      }
      if (parseInt(e.target.value) < 0) {
        e.target.value = Math.abs(e.target.value);
        this.$notify({
          type: "warning",
          message: "金额不能小于0",
        });
      }
    },
    confirmChange() {
      // let params = this.servicePriceMap.map()
      saveOrUpdateBatchGoodsDynamicPrice({
        jsonStr: JSON.stringify(this.servicePriceMap),
      }).then((res) => {
        if (res.code == 1) {
          this.$notify.success({
            title: "提示",
            message: "保存成功",
            icon: "success",
            duration: 2e3,
          });
        } else {
          this.$notify.error({
            title: "提示",
            message: res.msg,
            icon: "error",
            duration: 2e3,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-content {
    display: block;
    padding: 0 10px;
    margin: 0 auto;
    width: 50%;
  }
  .header-right {
    .el-select {
      width: 200px;
    }
  }
  .calendar {
    width: 600px;
    .zb-checkbox-indeterminate {
      .zb-checkbox {
        .zb-checkbox-inner {
          border-color: var(--c_main, #409eff);
          background: #fff;
          &:after {
            top: 6px;
            left: 2px;
            width: 10px;
            height: 2px;
            border: 0;
            background: var(--c_main, #409eff);
            transform: rotate(0deg);
          }
        }
      }
    }
    .zb-checkbox-checked {
      .date {
        border-color: #409eff;
        background: #409eff;
        opacity: 1 !important;
        color: #fff !important;
      }
      .zb-checkbox {
        .zb-checkbox-inner {
          border-color: var(--c_main, #409eff);
          background: var(--c_main, #409eff);
          &:after {
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAABGdBTUEAALGPC/xhBQAAASxJREFUOBGlkr9LQlEUx01Di1pCCKQhkAZxaMs/oFnwD3Bwqcmh0cnB0ak5HBwdHNyT5sDFIUIQxMXBQWgIIjB7fa7c+zjvvnfR9MCH8+t7vtOJxfYMz/OyMIIniB/u44dBhvs+ZCEHX7BbYHYGbyBjtpMbDifwKp2ol1D8tyFHSXgGGb805YAZg+PAIKJBE4cu2FH15WyOoA8fUPAXEQX7FthRD0jZdoRiQZ0PCHTDvCl0pnwMadlMzFbnGflSCulrlka1bTiQunXN8AY+QcaY5lwJyPdyoeseOREyMwOWt/CtxSYNKe5gZQY6v5BT5taZEZXgRx+50oDFqdPEXiCugPqpqHhnmLZvNvYcPUS4TZldbDx2CThuCNM59ZVLu/UcE/V36qWutz5C+AfE+OIwPOZePgAAAABJRU5ErkJggg==);
            transform: scale(1);
          }
        }
      }
    }
    .zb-checkbox-wrap {
      cursor: pointer;
      font-weight: 400;
      margin: 0;
      padding: 0;
      margin-right: 15px;
      vertical-align: middle;
      &:last-child {
        margin-right: 0;
      }
    }
    .zb-checkbox {
      position: relative;
      display: inline-block;
      width: 16px;
      height: 16px;
      white-space: nowrap;
      outline: none;
      vertical-align: middle;
      line-height: 1;
      margin: 0;
      padding: 0;
      & > input {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        opacity: 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
    .zb-checkbox-inner {
      position: relative;
      top: 0;
      left: 0;
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 2px;
      border: 1px solid #c8c9cc;
      background: #fff;
      box-sizing: border-box;
      transition: all 0.3s;
      &:after {
        box-sizing: content-box;
        position: absolute;
        display: block;
        content: " ";
        font-size: 0;
        top: 3px;
        left: 2px;
        width: 10px;
        height: 8px;
        background-size: contain;
        transform: scale(0);
        transition: all 0.12s ease-in-out;
      }
    }
    .calendar-header {
      position: relative;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .grid-btn {
        color: #409eff;
        border-color: #409eff;
      }
      .date-ctrl {
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;
        .date {
          font-size: 24px;
          color: #323233;
          // width: 140px;
          text-align: center;
          line-height: 21px;
        }
        .arrow {
          position: relative;
          width: 16px;
          height: 20px;
          padding: 0 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          .zb-pagination-arrow {
            stroke: #323233;
          }
          &.disable {
            cursor: no-drop;
            .zb-pagination-arrow {
              stroke: #c8c9cc;
            }
          }
        }
      }
    }
    .calendar-body {
      .zb-grid {
        font-size: 14px;
        color: #323233;
        position: relative;
        line-height: 1.5;
        overflow: hidden;
        &.zb-grid-bordered {
          td,
          th {
            box-shadow: inset 1px -1px 0 0 #ebedf0;
          }
          tr:first-of-type {
            th:first-of-type {
              // box-shadow: none;
            }
          }
        }
      }
      .title {
        margin-left: -8px;
        & > i {
          font: inherit;
          display: inline-block;
          transform: translateY(3px);
        }
      }
      .zb-grid-table {
        border-right: 1px solid #ebedf0;
        border-top: 1px solid #ebedf0;
        width: 100%;
        text-align: left;
        border-collapse: collapse;
        border-spacing: 0;
      }
      .zb-grid-td {
        position: relative;
        height: 84px;
        line-height: 20px;
        padding: 8px 16px;
        font-size: 14px;
        display: table-cell;
        box-sizing: border-box;
        vertical-align: middle;
        .zb-checkbox-wrap {
          transform: translateY(-28px);
        }
      }
      .zb-grid-tr {
        display: table-row;
        height: 56px;
        background-color: #fff;
        &:hover {
          background: #fff;
        }
        .zb-grid-th {
          line-height: 20px;
          padding: 18px 16px;
          font-weight: 500;
          background-color: #f7f8fa;
          font-size: 14px;
          box-sizing: border-box;
          display: table-cell;
          vertical-align: middle;
        }
      }
      .management-td-wrap {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        cursor: pointer;
        .tag {
          position: absolute;
          right: 0;
          top: 0;
          background: red;
          color: #fff;
          padding: 2px;
          &.notholiday {
            background-color: #409eff;
          }
        }
        & > .checkbox {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 10;
          .zb-checkbox-wrap {
            padding: 4px 0 8px 8px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            transform: translateY(0);
          }
        }
        &:hover {
          background: #ecf5ff;
          .add-tips {
            display: block;
          }
        }
        &.disable {
          opacity: 0.4;
          background: none;
          :after {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 10;
          }
        }
        .add-tips {
          position: absolute;
          bottom: 7px;
          left: 8px;
          font-size: 14px;
          color: #409eff;
        }
        .date {
          display: block;
          height: 100%;
          color: #409eff;
          opacity: 0.2;
          font-size: 40px;
          line-height: 84px;
          text-align: center;
        }
        & > .checkbox {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          z-index: 10;
          .zb-checkbox-wrap {
            display: block;
            // padding: 4px 0 8px 8px;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            transform: translateY(0);
          }
        }
        .count {
          position: absolute;
          right: 8px;
          top: 8px;
          color: #409eff;
          font-size: 14px;
        }
        .name-list {
          position: absolute;
          width: calc(100% - 1px);
          height: 24px;
          bottom: 0;
          left: 1px;
          box-sizing: border-box;
          background: #409eff;
          color: #fff;
          padding: 0 8px;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .schedule-calendar-pop {
        transform: translateY(40px);
      }
    }
  }
  .service-list {
    padding: 10px 0;
    .title {
      font-size: 22px;
      margin-bottom: 10px;
    }
    .el-tag {
      margin: 0 10px 10px 0;
    }
  }
  .price-change-list {
    .title {
      font-size: 22px;
      margin-bottom: 10px;
    }
    .date-list-wrap {
      & > div {
        margin-bottom: 10px;
        .el-button {
          margin: 0 10px 10px 0;
        }
      }
    }
    .service-price-list {
      border-bottom: 1px solid #ccc;
      margin-bottom: 10px;
      .service-item {
        padding-left: 10px;
        border: 1px solid #ccc;
        border-bottom: 0;
        .name {
          width: 300px;
          font-size: 16px;
          box-sizing: border-box;
        }
        .item {
          display: flex;
          padding: 10px 0;
          &.products {
            .name {
              padding-left: 50px;
            }
          }
          & > div.fixed-width {
            margin-right: 20px;
          }
          .fixed-width {
            width: 124px;
            display: flex;
            align-items: center;
            justify-content: center;
            .el-input {
              width: 140px;
            }
          }
          .indefinite-width {
            .el-input {
              width: 100px;
              margin: 0 16px 0 10px;
            }
            .el-tag {
              margin-right: 10px;
            }
            .el-button--text {
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
  .list-footer {
  }
}
.schedule-dialog {
  .list-none {
    text-align: center;
    font-size: 14px;
    color: #999999;
    padding: 200px;
    & > p {
      margin: 10px 0;
    }
  }
  .schedule {
    .time-list {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      span {
        font-size: 14px;
        opacity: 0.5;
      }
      p {
        flex: 1;
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .list {
      height: 500px;
      overflow-y: scroll;
      .item {
        .schedule-title {
          line-height: 52px;
          font-size: 12px;
          background: #f7f8fa;
          margin-bottom: 16px;
          padding: 0 16px;
          box-sizing: border-box;
          span {
            opacity: 0.5;
            margin-left: 6px;
          }
        }
        .craftsman-list {
          display: flex;
          flex-wrap: wrap;
          .craftsman-item {
            position: relative;
            background: #f5f5f5;
            border-radius: 4px;
            font-size: 14px;
            padding: 8px;
            width: calc(16.66667% - 8px);
            margin-bottom: 12px;
            margin-right: 8px;
            height: 57px;
            color: #323233;
            box-sizing: border-box;
            &:nth-of-type(6n) {
              margin-right: 0;
            }
            .nickname {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .el-icon-error {
              font-size: 20px;
              position: absolute;
              right: -5px;
              top: -5px;
              cursor: pointer;
            }
          }
          .craftsman-add {
            font-size: 12px;
            border: 1px dashed rgba(50, 50, 51, 0.15);
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #ffffff;
            cursor: pointer;
            i {
              margin-right: 5px;
            }
          }
        }
      }
    }
    .action {
      text-align: center;
      padding: 15px 0;
    }
  }
}
.popup-container {
  height: 500px;
  .el-input {
    margin: 10px 0;
  }
  .checkbox-list {
    height: calc(100% - 150px);
    .el-checkbox {
      display: block;
      margin-bottom: 10px;
    }
  }
  .el-button {
    float: right;
  }
}
.out-scheduling-details {
  .date {
    padding: 10px;
    border-bottom: 0.5px solid #ccc;
  }
  .list {
    min-height: 100px;
    max-height: 300px;
    overflow: auto;
    .item {
      .schedule-title {
        position: relative;
        font-size: 12px;
        line-height: 30px;
        padding-left: 10px;
        box-sizing: border-box;
        span {
          opacity: 0.5;
          margin-left: 6px;
        }
        &::before {
          content: "";
          display: block;
          position: absolute;
          top: 8px;
          bottom: 8px;
          left: 0;
          width: 2px;
          border-radius: 2px;
          background: #409eff;
        }
      }
      .craftsman-list {
        display: flex;
        flex-wrap: wrap;
        .craftsman-item {
          width: 50%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-left: 10px;
          box-sizing: border-box;
          font-size: 12px;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
